import {
  USER_STATUS_CODE_ACTIVE,
  USER_STATUS_CODE_BLOCKED,
  USER_STATUS_CODE_IMPORTED,
  USER_STATUS_CODE_INVITED,
  USER_STATUS_CODE_NOT_CONFIRMED,
} from '../../../constants/user'
import { USER_PROFILE_ACTION, USER_PROFILE_ACTION_PERMISSION } from '../../User'

import DeleteIcon from '../../../icons/delete.svg'

export const USER_PROFILE_PAGE_HEADER_FOOTER_ACTION = {
  ...USER_PROFILE_ACTION,
  approveRegistration: 'approveRegistration',
  email: 'email',
  sendMessage: 'sendMessage',
}

export const USER_PROFILE_PAGE_HEADER_FOOTER_ACTION_PERMISSION = {
  ...USER_PROFILE_ACTION_PERMISSION,
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.approveRegistration]: 'can_validate',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.email]: 'can_send_email',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendMessage]: 'can_start_new_chat',
}

export const USER_PROFILE_PAGE_HEADER_FOOTER_ACTION_TEXT_KEY = {
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.approveRegistration]:
    'User.ApproveRegistrationActionOptionKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.archive]:
    'User.ArchiveActionOptionKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.block]: 'User.BlockActionOptionKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.contract]:
    'UserProfile.HeaderFooterAddNewContractOptionKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.delete]: 'Modal.DeleteBtnKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.email]:
    'Profile.ActionsWidgetAddNewEmailKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.folder]:
    'Profile.ActionsWidgetAddNewFolderKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.restore]:
    'User.RestoreActionOptionKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendInvite]:
    'User.SendInviteActionOptionKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendMessage]:
    'UserProfile.HeaderFooterSendMessageOptionKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.serviceRequest]:
    'UserProfile.HeaderFooterAddNewServiceRequestOptionKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.unblock]:
    'User.UnblockActionOptionKey',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.upload]:
    'UserProfile.HeaderFooterUploadDocumentOptionKey',
}

export const USER_PROFILE_PAGE_HEADER_FOOTER_ADD_NEW_ACTIONS = [
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.email,
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.serviceRequest,
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.contract,
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.upload,
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.folder,
  USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendMessage,
]

export const USER_PROFILE_PAGE_HEADER_FOOTER_PRIMARY_ACTION_BY_STATUS = {
  [USER_STATUS_CODE_ACTIVE]: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.addNew,
  [USER_STATUS_CODE_BLOCKED]: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.unblock,
  [USER_STATUS_CODE_IMPORTED]:
    USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendInvite,
  [USER_STATUS_CODE_INVITED]: USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendInvite,
  [USER_STATUS_CODE_NOT_CONFIRMED]:
    USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.approveRegistration,
}

export const USER_PROFILE_PAGE_HEADER_FOOTER_QA_NAME = {
  addNew: 'userProfileAddNew',
}

export const USER_PROFILE_PAGE_HEADER_FOOTER_SECONDARY_ACTION_ICON = {
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.delete]: DeleteIcon,
}

export const USER_PROFILE_PAGE_HEADER_FOOTER_SECONDARY_ACTION_QA_NAME = {
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.delete]: 'userProfileDelete',
}

export const USER_PROFILE_PAGE_HEADER_FOOTER_PRIMARY_ACTION_QA_NAME = {
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.approveRegistration]:
    'userProfileApproveRegistration',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.restore]: 'userProfileRestore',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendInvite]: 'userProfileSendInvite',
  [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.unblock]: 'userProfileUnblock',
}
